var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('cr-header'),_c('cr-menu'),_c('router-view'),_c('notifications',{attrs:{"group":"general-notification","position":"top right","width":"420","animation-type":"velocity","duration":4000}}),_c('cr-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }